import { useState,useEffect } from 'react';
import  styles from './DataList.module.css';
import { dataList } from '../../constants';

function RequiredItem({title,detail,category,target,requiredName,selected,onClick}) {
  // const [selected, setSelected] = useState(false);
  const handleClick = () => {
    if(target!=0){
        // setSelected(!selected);
        onClick(target==selected?-1:target);
    }
  };

  return (
    <div className={`${styles['list-item']} ${selected==target ? styles['item-selected'] : ''}`} onClick={handleClick}>
        <div className={styles['item-main']}>
            <div className={styles['main-title']}>{title}</div>
            <div className={styles['main-detail']}>{detail}</div>
        </div>
        <div className={styles['item-sub']}>
            <div className={styles['sub-class']}>
                <div className={styles['class-svg']}></div>
                <div className={styles['class-text']}>{category==""?"Temp Slot":category}</div>
            </div>
            <div className={styles['sub-class']}>
                <div className={styles['users-svg']}></div>
                <div className={styles['users-text']}>Samples 70,000</div>
            </div>
            <div className={styles['sub-class']}>
                <div className={styles['counts-svg']}></div>
                <div className={styles['counts-text']}>Format 28x28</div>
            </div>
        </div>
    </div>
  );
}

export default function DataList({handleDataSelected}) {
  const [listUpdate,setListUpdate]=useState(false);
  const [selected, setSelected] = useState(-1);
  useEffect(()=>{
    if(listUpdate){
      setTimeout(() => {
       setListUpdate(false); 
      }, 500);
    };
  })

  const handleRequiredItem=((requiredName,selected)=>{
    setSelected(selected);
    handleDataSelected(requiredName,selected)
  })

  return (
    <div className={styles["body-requiredData"]}>
      <div className={styles["body-requiredData-title"]}>
        <span>Required Data</span>
        <span>{selected==-1?"Select Dataset":dataList[selected-1].title}</span>
      </div>
      <div className={styles["requiredData-list"]}>
        {dataList.map((dataListRow,index)=>
        <>
        <RequiredItem 
        title={dataListRow.title} 
        detail={dataListRow.detail} 
        category={dataListRow.category}
        target={dataListRow.target} 
        requiredName={dataListRow.requiredName}
        selected={selected}
        onClick={(selected)=>handleRequiredItem(dataListRow.requiredName,selected)}/>
        {index < dataList.length-1 && <hr/>}
        </>
        )}
     </div>
    </div>
  );
}